import {equipmentOidTypes} from '@/components/mixins/ConversionMixin'

export default class VelhoCulvertModel {
    // Private properties
    /** @type {string} */
    _external_system_id = equipmentOidTypes.EXTERNAL_CULVERTS

    /**
     * Creates an instance of Velho culvert model.
     * Editor will transform the number to a string, because of html input field. We should convert those values back to numbers before sending the data to the server
     */
    constructor(
        type = null, material = null, size = null, length = null, condition = null, position = { x: null, y: null }, roadNum = null, roadSec = null, distance = null,
        locationSpecification = { lane: [], side: null, tracks: null, central_area: null }, locationDeviation = null, equipmentDamages = [], externalSystemId = ""
    ) {
        /** @type {number | null} */
        this.type = type

        /** @type {number | null} */
        this.material = material

        /** @type {number | null} */
        this.size = size

        /** @type {number | null} */
        this.length = length

        /** @type {number | null} */
        this.condition = condition

        /** @type {{ x: number, y: number }} */
        this.position = position

        /** @type {number | null} */
        this.road_num = roadNum

        /** @type {number | null} */
        this.road_sec = roadSec

        /** @type {number | null} */
        this.distance = distance

        /** @type {Array} */
        this.equipment_damages = equipmentDamages

        /** @type {number | null} */
        this.location_deviation = locationDeviation

        /** @type {{ lane: number[], side: number | null, tracks: number | null, central_area: number | null }} */
        this.location_specification = locationSpecification

        if(externalSystemId) {
            this._external_system_id = externalSystemId
        }
    }

    /**
    * Gets the unique identifier of the Velho culvert type.
    * @returns {string} The Velho culvert type ID.
    */
    get external_system_id() {
        return this._external_system_id
    }

    /**
    * Get the culvert json object.
    * @returns {object}
    */
    toJSON() {
        return JSON.parse(
            JSON.stringify({
            external_system_id: this._external_system_id,
            type: this.type,
            material: this.material,
            size: this.size,
            length: this.length,
            condition: this.condition,
            position: this.position,
            road_num: this.road_num,
            road_sec: this.road_sec,
            distance: this.distance,
            equipment_damages: this.equipment_damages,
            location_deviation: this.location_deviation,
            location_specification: {
                ...this.location_specification,
                tracks: this.location_specification.tracks !== null ? [this.location_specification.tracks] : []
            }
        }))
    }

    /**
    * Create default Velho culvert instance with position data.
    * @param {{ x: number, y: number }} position - coordinates.
    * @param {number | null} roadNum - Road number.
    * @param {number | null} roadSec - road section.
    * @param {number | null} distance - distance (road geometry).
    * @returns {VelhoCulvertModel} A new Velho culvert instance.
    */
    static instanceWithPosition(position, roadNum, roadSec, distance) {
        const instance = new VelhoCulvertModel()
        instance.position = position
        instance.road_num = roadNum
        instance.road_sec = roadSec
        instance.distance = distance
        return instance
    }
}
